import React, { useEffect, useState, useRef } from 'react';
import { VehicleDataModel, VehicleOwnership, DynamicObject5, ManufacturerModel, VehicleSubModelModel, VehicleModelModel, RiderModel, SubscriberModel } from '../models/superbit-api-models';
import { GeneralDataModel } from '../models/GeneralDataModel';
import '../assets/css/_simple-popup.css'
import './_VehicleDetails.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SimulatorModel, } from '../models/SimulatorModel';
import { DynamicSelect } from '../components/_DynamicSelect';
import { IDNameDescriptionItemSelect } from '../components/_IDNameDescriptionItemSelect';
import { IDNameDescriptionItem, IDNameDescriptionDictionary, AutocompleteData } from '../models/Site'
import { Autocomplete } from '../components/_Autocomplete';
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import { SubscribersModel } from '../models/SubscribersModel'
import VehicleDetails from "../vehicles/_VehicleDetails"
type Props = {
    vehicle: VehicleDataModel,
    vehicles: Array<VehicleDataModel> | null,
    UpdateVehicle: Function,
    VehicleValidation: Function,
    ValidationMode: string,
    existVehicle?: boolean
};



class VehicleDetailsData {
    tozeretCd?: number;
    degemCd?: number;
    manufacturerId?: string;
    vehicleModelId?: string;
    vehicleSubModelId?: string;
    modelCode?: string;
    carYear?:number;
};



const VehicleData = (props: Props) => {

    const [vehicleId, setVehicleId] = useState<string | undefined>("");
    const [licenseNumber, setLicenseNumber] = useState<string | undefined>(undefined);
    const [lastLicenseNumber, setLastLicenseNumber] = useState<string | undefined>(undefined);
    const [carYear, setCarYear] = useState<number | undefined>(undefined);
    const [modelCode, setModelCode] = useState<string | undefined>(undefined);
    const [lastModelCode, setLastModelCode] = useState<string | undefined>(undefined);

    const [vehicleOwnership, setVehicleOwnership] = useState<VehicleOwnership | undefined>(undefined);
    const [automaticInd, setAutomaticInd] = useState<boolean | undefined>(undefined);
    const [entryToRoadDate, setEntryToRoadDate] = useState<Date | undefined>(undefined);
    const [esp, setEsp] = useState<boolean | undefined>(undefined);
    const [fcw, setFcw] = useState<boolean | undefined>(undefined);
    const [ldw, setLdw] = useState<boolean | undefined>(undefined);
    const [manufacturerText, setManufacturerText] = useState<string | undefined>(""/*props.vehicle.vehicleSubModel?.vehicleModel?.manufacturer?.name*/);
    const [manufacturerId, setManufacturerId] = useState<string | undefined>(""/*props.vehicle.vehicleSubModel?.vehicleModel?.manufacturerId*/);
    const [vehicleModelText, setVehicleModelText] = useState<string | undefined>(""/*props.vehicle.vehicleSubModel?.vehicleModelId*/);
    const [vehicleModelId, setVehicleModelId] = useState<string | undefined>(""/*props.vehicle.vehicleSubModel?.vehicleModel?.name*/);
    const [vehicleSubModelText, setVehicleSubModelText] = useState<string | undefined>(""/*props.vehicle.vehicleSubModel?.name*/);
    const [vehicleSubModelId, setVehicleSubModelId] = useState<string | undefined>(""/*props.vehicle.vehicleSubModelId*/);
    const [VehicleOwnerships, setVehicleOwnerships] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [CarYears, setCarYears] = useState<Array<string>>([]);
    const [Vehicle, setVehicle] = useState<VehicleDetailsData | null>(new VehicleDetailsData());
    const [licenseNumberLoading, setLicenseNumberLoading] = useState<boolean>(false);
    const [showVehicleDetails, setShowVehicleDetails] = useState<boolean>(false);
    const [missingVehicleDetails, setMissingVehicleDetails] = useState<boolean>(false);
    const [showVehiclePopup, setShowVehiclePopup] = useState<boolean>(false);
    const [ModelcodeAutocomplete, setModelcodeAutocomplete] = useState<Array<AutocompleteData>>([]);
    const [modelError, setModelError] = useState<boolean>(false);
    const [modelCodeLoading, setModelCodeLoading] = useState<boolean>(false);
    const [VehicleForUpdate, setVehicleForUpdate] = useState<VehicleDataModel>(new VehicleDataModel());
    const [VehicleValidation, setVehicleValidation] = useState<VehicleDataModel>(new VehicleDataModel());
    const [licenseNumberFromList, setLicenseNumberFromList] = useState<boolean>(false);
    const [vehiclesList, setVehiclesList] = useState<Array<VehicleDataModel> | null>(props.vehicles);
    const [vehicleErrMsg, setVehicleErrMsg] = useState<string>("");
    const [doubleErrMsg, setDoubleErrMsg] = useState<string>("");
    const [yearErrMsg, setYearErrMsg] = useState<string>("");
    const hasMounted = useRef(false);

    
    useEffect(() => {
        if (hasMounted.current) {
            vehicleValidation();
        } else {
            hasMounted.current = true;
        }

    }, [props.ValidationMode])

    useEffect(() => {
        
var v= vehicleId;

    }, [vehicleId])


    useEffect(() => {
        if (props.vehicles && props.vehicles.length > 0) {
            setLicenseNumberFromList(true);
        }

    }, [props.vehicles])

    useEffect(() => {
        if (props.vehicle) {
            // setLicenseNumber(props.vehicle.licenseNumber)
            // setVehicleSubModelId(props.vehicle.vehicleSubModelId);
            // setVehicleModelText(props.vehicle.vehicleSubModel && props.vehicle.vehicleSubModel.vehicleModel ? props.vehicle.vehicleSubModel.vehicleModel.name : "" );
            // setManufacturerText(props.vehicle.vehicleSubModel && props.vehicle.vehicleSubModel.vehicleModel && props.vehicle.vehicleSubModel.vehicleModel.manufacturer ? props.vehicle.vehicleSubModel.vehicleModel.manufacturer.name : "" );
        }

    }, [props.vehicle])


    useEffect(() => {
        init();
        console.log('props.vehicle', props.vehicle)
    }, [])

    

    const init = async () => {
        
        setVehicleOwnerships(await new SimulatorModel().getVehicleOwnership());

        // set list of all years from 30 years ago to current year
        var CarYears = [];
        for (let i: number = new Date().getFullYear() + 1; i >= new Date().getFullYear() - 31; i--) {
            CarYears.push(i + "");
        }
        setCarYears(CarYears);

        if (props.vehicle && props.vehicle.vehicleSubModel && props.vehicle.vehicleSubModel.vehicleModel && props.vehicle.vehicleSubModel.vehicleModel.manufacturer) {
            console.log("setManufacturerText = init");

            setManufacturerText(props.vehicle.vehicleSubModel.vehicleModel.manufacturer.name);
            setManufacturerId(props.vehicle.vehicleSubModel.vehicleModel.manufacturerId);
        }

        if (props.vehicle && props.vehicle.vehicleSubModel && props.vehicle.vehicleSubModel.vehicleModel) {
            setVehicleModelText(props.vehicle.vehicleSubModel.vehicleModel.name);
            setVehicleModelId(props.vehicle.vehicleSubModel.vehicleModelId);
        }

        if (props.vehicle && props.vehicle.vehicleSubModel) {
            // need to check if to uncomment this line ???
            setVehicleSubModelText(props.vehicle.vehicleSubModel.name);
            setVehicleSubModelId(props.vehicle.vehicleSubModelId);
            if (props.vehicle.vehicleSubModelId && validateGUID(props.vehicle.vehicleSubModelId)) {
                HandleVehicleValidation(true);
            }
        }

        await setLicenseNumber(props.vehicle.licenseNumber);
        if(props.vehicle.licenseNumber){
        var res =await  new SubscribersModel().RiderCheckActiveVehicle(props.vehicle.licenseNumber);
            if(res.doubleLead){
                setDoubleErrMsg("לרכב מנוי פעיל");
            }
            else{
                setDoubleErrMsg("");
            }
        }else if(!licenseNumber || licenseNumber === ''){
            HandleEmptyVehicleValidation(false);
        }


         
        setLastLicenseNumber(props.vehicle.licenseNumber);
        setCarYear(props.vehicle.carYear);
        setModelCode(props.vehicle.modelCode);
        setLastModelCode(props.vehicle.modelCode);

        setVehicleOwnership(props.vehicle.vehicleOwnership);
        setAutomaticInd(props.vehicle.automaticInd);
        setEntryToRoadDate(props.vehicle.entryToRoadDate);
        setEsp(props.vehicle.esp);
        setFcw(props.vehicle.fcw);
        setLdw(props.vehicle.ldw);
        if(props.vehicle.id)
            setVehicleId(props.vehicle.id);

    };

    function validateGUID(guid: string) {
        const guidPattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
        return guidPattern.test(guid);
    }

    const HandleEmptyVehicleValidation = (valid: boolean) =>{
        // if (!valid) {
        //     setVehicleErrMsg("שדה חובה");
        // } else {
        //     setVehicleErrMsg("");
        // }
        console.log('VehicleValidation-HandleEmptyVehicleValidation', valid);
        props.VehicleValidation(valid);
    }

    const HandleVehicleValidation = (valid: boolean) => {
        if (!valid) {
            setVehicleErrMsg("פרטי הרכב לא אותרו, אנא הקלד קוד דגם או מס' רכב אחר");
        } else {
            setVehicleErrMsg("");
        }
        console.log('VehicleValidation-HandleVehicleValidation', valid);
        props.VehicleValidation(valid);
    }


    const validateModelCode = (modelCode: string): boolean => {
        const regex = /^(?:[1-3]\d{6}|[0-9]{6})$/;
        return regex.test(modelCode);
    }

    const loadModelCode = async (search: string) => {
        // 
        let modelcodeAll: any[] = [];
        setModelCode(search ? search : '');


        if (search && search.length >= 3) {
            modelcodeAll = await new SimulatorModel().getModelCode(search);
            const modelcodeAutocomplete = modelcodeAll.filter((item: any) => item.label !== null && item.val !== null);
            setModelcodeAutocomplete(modelcodeAutocomplete);
        }

        if (search == null || !validateModelCode(search)) {
            setModelError(true);

        } else {
            if (validateModelCode(search)) {
                getModelCodeData(search)
            }
        }
    }

    const getModelDataByCode = async (code: string) => {
        let modelData: any = null;
        try {

            modelData = await new SimulatorModel().getModelDetailsByModelCode(code, licenseNumber);
            if (modelData.manufacturer) {
                console.log('loadModelCode', code, modelData);
            }
        } catch (error) {

        }
        return modelData;
    }

    const getModelCodeData = async (code: string) => {

        if (code && code !== '' && lastModelCode != code) {
            setModelCodeLoading(true);
            setLastModelCode(code);
            clearModelVehicleData();

            const data = await getModelDataByCode(code);
            console.log('getModelCodeData', data)

            if (data) {

                const vehicle: VehicleDetailsData = new VehicleDetailsData();

                if (data.LeviItzhak != null) {
                    vehicle.modelCode = code;
                    setVehicleData(data.LeviItzhak, licenseNumber,true);

                }
                setMissingVehicleDetails(false);
                HandleVehicleValidation(true);


            } else {
                setVehicle(null);
                HandleVehicleValidation(false);
            }

        }
        else {
            clearModelVehicleData();
        }
        setModelCodeLoading(false);
    }


    const editCarYear = async (name: string, value: any) => {
        let _licenseNumber = licenseNumber || undefined;
        var data = await new SimulatorModel().getVehicleDetailsByLicenseNumber(_licenseNumber || "");
            // 
            if (data && data.LeviItzhak) {
                setVehicleData(data.LeviItzhak, _licenseNumber,false, value);

            }
        setCarYear(value);
    }

    const clearVehicleData = async () => {

        setModelCode("");
        setAutomaticInd(true);
        setCarYear(new Date().getFullYear());
        setEntryToRoadDate(undefined);
        setManufacturerId("");
        setManufacturerText("");
        setVehicleModelId("");
        setVehicleModelText("");
        setVehicleSubModelId("");
        setVehicleSubModelText("");
        setEsp(false);
        setFcw(false);
        setLdw(false);
        setVehicleId("");

        var _vehicle = new VehicleDetailsData();
        _vehicle.manufacturerId = "";
        _vehicle.vehicleModelId = "";
        _vehicle.vehicleSubModelId = "";
        _vehicle.modelCode = "";
        _vehicle.tozeretCd = undefined;
        _vehicle.carYear = undefined;
        _vehicle.degemCd = undefined;
        
        var _VehicleForUpdate = VehicleForUpdate;
        _VehicleForUpdate.id = undefined;
        setVehicleForUpdate(_VehicleForUpdate);

        var _VehicleValidation = VehicleValidation;
        _VehicleValidation.id = undefined;
        setVehicleValidation(_VehicleValidation);

        setVehicle(_vehicle);
    }

    const clearModelVehicleData = () => {

        //setLicenseNumber("");
        setAutomaticInd(true);
        setCarYear(new Date().getFullYear());
        setEntryToRoadDate(undefined);
        setManufacturerId("");
        setManufacturerText("");
        setVehicleModelId("");
        setVehicleModelText("");
        setVehicleSubModelId("");
        setVehicleSubModelText("");
        setEsp(false);
        setFcw(false);
        setLdw(false);

        var _vehicle = new VehicleDetailsData();
        _vehicle.manufacturerId = "";
        _vehicle.vehicleModelId = "";
        _vehicle.vehicleSubModelId = "";
        _vehicle.modelCode = "";
        _vehicle.tozeretCd = undefined;
        _vehicle.degemCd = undefined;
        _vehicle.carYear = undefined;

        setVehicle(_vehicle);
    }

    const getVehicleDetails = async (event: any) => {

        var _licenseNumber = event.currentTarget.value.trim();
        clearVehicleData();

        if (_licenseNumber.length > 0 && lastLicenseNumber != _licenseNumber.length) {
            var res =await  new SubscribersModel().RiderCheckActiveVehicle(_licenseNumber);
            if(res.doubleLead){
                setDoubleErrMsg("לרכב מנוי פעיל");
            }else{
                setDoubleErrMsg("");
            }
        
            setLicenseNumber(_licenseNumber);
            setLicenseNumberLoading(true);

            const _vehicle: VehicleDetailsData = new VehicleDetailsData();
            var data = await new SimulatorModel().getVehicleDetailsByLicenseNumber(_licenseNumber);
            // 
            if (data && data.LeviItzhak) {
                setVehicleData(data.LeviItzhak, _licenseNumber,false);

            } else {
                setModelCode('');
                setVehicle(null);
                HandleVehicleValidation(false);
            }
            setLicenseNumberLoading(false);
        }

    }

    const openVehiclePopup = async () => {
        if (localStorage.getItem("isAdminUser") == "true") {
            await setShowVehiclePopup(true);
        }
    }

    const vehicleValidation = () => {
        HandleVehicleValidation(!(vehicleSubModelId == undefined || vehicleSubModelId.length == 0));
    }


    const setVehicleData = (data: DynamicObject5, _licenseNumber: string | undefined,isModelCodeLoading:boolean, carYearValue?: number) => {
        const _vehicle: VehicleDetailsData = new VehicleDetailsData();
        if (data) {


            var v = new VehicleDataModel();
            //????
            v.licenseNumber = _licenseNumber;
            v.automaticInd = true;
            v.vehicleSubModel = new VehicleSubModelModel();
            v.vehicleSubModel.vehicleModel = new VehicleModelModel();
            v.vehicleSubModel.vehicleModel.manufacturer = new ManufacturerModel();
            v.manufacturer = new ManufacturerModel();
            v.vehicleModel = new VehicleModelModel();
            console.log('getVehicleDetails', data);
            if (data != null) {
                setMissingVehicleDetails(false);
                    
                if (data.error != null && data.error.code && (data.error.code != 0)) {
                    setMissingVehicleDetails(true);
                    setShowVehicleDetails(true);
                    HandleVehicleValidation(false);


                }
                else {
                    setShowVehicleDetails(true);
                    HandleVehicleValidation(true);

                }
                if (data.manufacturer != null) {
                    _vehicle.manufacturerId = data.manufacturer.val
                    setManufacturerId(data.manufacturer.val);
                    setManufacturerText(data.manufacturer.label);

                    v.vehicleSubModel.vehicleModel.manufacturer.name = data.manufacturer.label;
                    v.vehicleSubModel.vehicleModel.manufacturer.id = data.manufacturer.val;
                    v.vehicleSubModel.vehicleModel.manufacturerId = data.manufacturer.val;
                    v.manufacturer.id = data.manufacturer.val;
                    v.manufacturer.name = data.manufacturer.label;
                }
                if (data.vehicleModel != null) {
                    _vehicle.vehicleModelId = data.vehicleModel.val;
                    setVehicleModelId(data.vehicleModel.val);
                    setVehicleModelText(data.vehicleModel.label);

                    v.vehicleSubModel.vehicleModel.name = data.vehicleModel.label;
                    v.vehicleSubModel.vehicleModel.id = data.vehicleModel.val;
                    v.vehicleModel.name = data.vehicleModel.label;
                    v.vehicleModel.id = data.vehicleModel.val;
                    v.vehicleSubModel.vehicleModelId = data.vehicleModel.val;

                }
                if (data.vehicleSubModel != null) {
                    setModelCode(data.vehicleSubModel.code);
                    v.modelCode = data.vehicleSubModel.code;
                    v.vehicleSubModel.modelCode = data.vehicleSubModel.code;
                    //v.licenseNumber = _licenseNumber;
                    setVehicleSubModelId(data.vehicleSubModel.val);
                    setVehicleSubModelText(data.vehicleSubModel.label);
                    v.vehicleSubModel.name = data.vehicleSubModel.label;
                    v.vehicleSubModelId = data.vehicleSubModel.val;
                    v.vehicleSubModel.id = data.vehicleSubModel.val;
                    _vehicle.vehicleSubModelId = data.vehicleSubModel.val;

                }

                setEsp(data.esp);
                v.esp = data.esp;
                setFcw(data.fcw);
                v.fcw = data.fcw;
                setLdw(data.ldw);
                v.ldw = data.ldw;

                if(/*isModelCodeLoading && (licenseNumber==undefined || licenseNumber.length==0)*/true){
                    v.carYear = carYearValue ?  carYearValue : data.carYear;
                    setCarYear(carYearValue ?  carYearValue : data.carYear);

                    if(carYearValue || data.carYear != undefined){
                        setCarYear(carYearValue ?  carYearValue : data.carYear);
                        setYearErrMsg("");
            
                    } else {
                        setYearErrMsg("לא נמצאה שנה");
                    }


                    _vehicle.carYear = data.carYear;
                    setEntryToRoadDate(data.entryToRoad);
                    v.entryToRoadDate = data.entryToRoad;
                }
                


                setVehicleOwnership(data.vehicleOwnership);
                v.vehicleOwnership = data.vehicleOwnership;
               

                _vehicle.modelCode = data.vehicleSubModel ? data.vehicleSubModel.code : "";
                _vehicle.tozeretCd = data.tozeretCd;
                _vehicle.degemCd = data.degemCd;
                
                props.UpdateVehicle(v);

            }

            setVehicle(_vehicle);
            setVehicleForUpdate(v);
        }
    }


    useEffect(() => {
        const checkActiveVehicle = async () => {
            console.log("!!!!!!!!!!!!!!!!!!!!!licenseNumber useEffect!!!!!!!!!!!!!!!!!!!!!!!!", licenseNumber);
            
            var v = VehicleForUpdate;
            v.licenseNumber = licenseNumber;
            setVehicleForUpdate(new VehicleDataModel(v));
    
            if (licenseNumber) {
                try {
                    const res = await new SubscribersModel().RiderCheckActiveVehicle(licenseNumber);
                    if (res.doubleLead) {
                        setDoubleErrMsg("לרכב מנוי פעיל");
                    }else{
                        setDoubleErrMsg("");
                    }
                } catch (error) {
                    console.error("Error checking active vehicle:", error);
                    // Handle error (e.g., show an error message)
                }
            }
        };
    
        checkActiveVehicle();
    }, [licenseNumber]);



    // useEffect(()  => {

    //     console.log("!!!!!!!!!!!!!!!!!!!!!licenseNumber useEffect!!!!!!!!!!!!!!!!!!!!!!!!", licenseNumber);
    //     var v = VehicleForUpdate;
    //     v.licenseNumber = licenseNumber;
    //     setVehicleForUpdate(new VehicleDataModel(v));
    //     if(licenseNumber){
    //         var res =await  new SubscribersModel().RiderCheckActiveVehicle(licenseNumber);
    //             if(res.doubleLead){
    //                 setDoubleErrMsg("לרכב מנוי פעיל");
    //             }
    //         }
    //     // setVehicleForUpdate(v);
    // }, [licenseNumber]);

    useEffect(() => {
        console.log("!!!!!!!!!!!!!!!!!!!!!!!!VehicleForUpdate useEffect!!!!!!!!!!!!!!!!!!!!!!", VehicleForUpdate);

        props.UpdateVehicle(VehicleForUpdate);

    }, [VehicleForUpdate]);

    useEffect(() => {
        setVehiclesList(props.vehicles);
        if(props.existVehicle && props.existVehicle == true && props.vehicles && props.vehicles.length > 0){
            setSelectVehicle(props.vehicles[0]);

        }
        // if (props.vehicles && props.vehicles.length > 0 /*&& licenseNumberFromList*/) {
        //     setSelectVehicle(props.vehicles[0]);
        // }

    }, [props.vehicles]);

    const setSelectVehicle =async (_vehicle: VehicleDataModel) => {
        
        var _v: VehicleDetailsData = new VehicleDetailsData();

        setVehicleId(_vehicle.id);
        await setLicenseNumber(_vehicle.licenseNumber);
        if(licenseNumber){
            var res =await  new SubscribersModel().RiderCheckActiveVehicle(licenseNumber);
                if(res.doubleLead){
                    setDoubleErrMsg("לרכב מנוי פעיל");
                }else{
                    setDoubleErrMsg("");
                }
            }
        setCarYear(_vehicle.carYear);
        setModelCode(_vehicle.modelCode==null?'':_vehicle.modelCode);
        _v.modelCode = _vehicle.modelCode
        setVehicleOwnership(_vehicle.vehicleOwnership);
        setAutomaticInd(_vehicle.automaticInd);
        setEntryToRoadDate(_vehicle.entryToRoadDate);
        setEsp(_vehicle.esp);
        setFcw(_vehicle.fcw);
        setLdw(_vehicle.ldw);


        if (_vehicle.vehicleSubModel && _vehicle.vehicleSubModel.vehicleModel && _vehicle.vehicleSubModel.vehicleModel.manufacturer) {
            
            console.log("setManufacturerText = setSelectVehicle");
            setManufacturerText(_vehicle.vehicleSubModel.vehicleModel.manufacturer.name);
            setManufacturerId(_vehicle.vehicleSubModel.vehicleModel.manufacturerId);

            _v.manufacturerId = _vehicle.vehicleSubModel.vehicleModel.manufacturerId;


        }

        if (_vehicle && _vehicle.vehicleSubModel && _vehicle.vehicleSubModel.vehicleModel) {
            setVehicleModelText(_vehicle.vehicleSubModel.vehicleModel.name);
            setVehicleModelId(_vehicle.vehicleSubModel.vehicleModelId);

            _v.vehicleModelId = _vehicle.vehicleSubModel.vehicleModelId;

        }

        if (_vehicle && _vehicle.vehicleSubModel) {
            setVehicleSubModelText(_vehicle.vehicleSubModel.name);
            setVehicleSubModelId(_vehicle.vehicleSubModelId);

            _v.vehicleSubModelId = _vehicle.vehicleSubModelId;

        }
        _v.carYear = _vehicle.carYear;


        setVehicle(_v);
        _vehicle.vehicleSubModel = new VehicleSubModelModel(_vehicle.vehicleSubModel);
        _vehicle.vehicleModel = new VehicleModelModel(_vehicle.vehicleSubModel.vehicleModel);
        if (_vehicle.vehicleSubModel.vehicleModel)
            _vehicle.manufacturer = new ManufacturerModel(_vehicle.vehicleSubModel.vehicleModel.manufacturer);
        setVehicleForUpdate(new VehicleDataModel(_vehicle));
    }




    const selectModelCode = async (id: string) => {
        // 
        if (!id) {
            return;
        }

        setModelCodeLoading(true);

        const data = await new SimulatorModel().getVehicleDetails(id);
        setModelCode(data.vehicleSubModel.code);
        // const data = await new SimulatorModel().getModelCode(id);

        const modelCodes: any[] = ModelcodeAutocomplete as any[];
        const modelCode = modelCodes.find(model => model.value == id);

        if (modelCode) {
            clearModelVehicleData();
            const code = modelCode.text.split(' - ')[0];
            const modelData = await getModelDataByCode(code);
            if (modelData) {

                console.log('getVehicleDetails', modelData);

                setVehicleData(modelData.LeviItzhak, licenseNumber,true);

                setMissingVehicleDetails(false);
                HandleVehicleValidation(true);
            }
            else {
                setVehicle(null);
                HandleVehicleValidation(false);
            }
            setModelCodeLoading(false);

            
        }
    }

    const onModelCodeFocus = async () => {
        setModelError(false);
    }

    const closeVehiclePopup = () => {
        setShowVehiclePopup(false);

    }

    const selectVehicle =async (id: string, value: string) => {

        console.log('id', id, 'value', value);
        if (value == "") {
            setLicenseNumberFromList(false);
            clearVehicleData();
            setLicenseNumber("");
            setVehicleId("");
            setVehicle(null);
            setVehicleErrMsg("שדה חובה");
        }
        else {
            if (vehiclesList) {
                var _v = vehiclesList.find(x => x.id === value);
                if (_v) {
                    setSelectVehicle(_v);
                    if(_v.licenseNumber){
                        var res =await  new SubscribersModel().RiderCheckActiveVehicle(_v.licenseNumber);
                            if(res.doubleLead){
                                setDoubleErrMsg("לרכב מנוי פעיל");
                            }else{
                                setDoubleErrMsg("");
                            }
                        }
                    HandleVehicleValidation(true);
                }
                else {
                    setVehicle(null);
                    HandleVehicleValidation(false);
                }
            }
        }


    }


    // function for connecting vehicle to the vehicle details
    const connectVehicle = async (vehicleSubmodelId?: string) => {

        if (vehicleSubmodelId) {
            setMissingVehicleDetails(false);
            const generalModel: GeneralDataModel = new GeneralDataModel();
            let data = await generalModel.getVehicleInfoGetVehicleSubModelsById(vehicleSubmodelId);
            var v = VehicleForUpdate;
            setVehicleSubModelId(vehicleSubmodelId);
            v.vehicleSubModelId = vehicleSubmodelId;
            console.log("setManufacturerText = connectVehicle");
            setManufacturerText(data.vehicleModel.manufacturer.name);
            setVehicleModelText(data.vehicleModel.name);
            setVehicleSubModelText(data.name);
            setManufacturerId(data.vehicleModel.manufacturer.id);
            setVehicleModelId(data.vehicleModel.id);
            setModelCode(data.modelCode);

            var v = VehicleForUpdate;
            v.vehicleSubModel = data;
            v.vehicleSubModelId = vehicleSubmodelId;
            v.vehicleModel = data.vehicleModel;
            v.modelCode = data.modelCode;
            v.manufacturer = data.vehicleModel.manufacturer;

            setVehicleForUpdate(new VehicleDataModel(v));

            const _vehicle: VehicleDetailsData = new VehicleDetailsData();
            _vehicle.manufacturerId = data.vehicleModel.manufacturer.id;
            _vehicle.vehicleModelId = data.vehicleModel.id;
            _vehicle.vehicleSubModelId = vehicleSubmodelId;
            _vehicle.modelCode = data.modelCode;
            _vehicle.carYear = data.year;
            setVehicle(_vehicle);

            closeVehiclePopup();
        }
    }

    const getVehicleOptions = () => {
        if (vehiclesList) {
            var options = vehiclesList
                .reduce((acc, vehicle: VehicleDataModel) => {
                    const key = vehicle.id!;
                    acc[key] = {
                        id: vehicle.id!,
                        name: vehicle.licenseNumber!,
                        description: vehicle.licenseNumber!
                    };
                    return acc;
                }, {} as IDNameDescriptionDictionary);

            // const key = "additional-option";
            const addNewOption: IDNameDescriptionItem = {
                id: "",
                name: "רכב חדש",
                description: "רכב חדש"
            };


            const additionalOption: IDNameDescriptionItem = {
                id: "",
                name: "בחר",
                description: "בחר"
            };

            
            // casting to array of IDNameDescriptionItem
            const optionsList = Object.keys(options).map(key => options[key]);
            optionsList.push(addNewOption);
            optionsList.unshift(additionalOption);
            // optionsList.unshift(additionalOption);

            // options["default"] = additionalOption

            console.log("getVehicleOptions", options);
            return optionsList;
        }
        return [];
    }


    return (
        <div>
            <div className="tab-content-title">
                פרטי רכב
            </div>
            <div className="parameter-row">
                <div className="parameter-item">
                    <div className="field">
                        <div className="title">
                            מס' רכב
                        </div>
                        <div className="value">
                            {!licenseNumberFromList ?
                                <input type="text"
                                    onBlur={(e: any) => getVehicleDetails(e)}
                                    value={licenseNumber}
                                    onChange={(e: any) => setLicenseNumber(e.target.value.trim())}
                                />
                                :
                                <select value={vehicleId} id="vehicleId" onChange={(e: any) => selectVehicle(e.target.id, e.target.value)}>
                                    {
                                        getVehicleOptions().map((option: IDNameDescriptionItem) => (
                                            <option key={option.id} value={option.id}>{option.description}</option>
                                        ))
                                    }
                                </select>
                                // <IDNameDescriptionItemSelect
                                //     OnChange={selectVehicle}
                                //     Id={""} Options={getVehicleOptions() as IDNameDescriptionDictionary}
                                //     Value={vehicleId} />
                            }
                            
                            <img src={require("../assets/images/loading.gif")} className={licenseNumberLoading ? "loadingGif" : "hide"} />
                        </div>
                        <div className='error-message2'>{vehicleErrMsg}</div>
                        <div className='error-message2'>{doubleErrMsg}</div>
                    </div>
                </div>



                <div className="parameter-item">
                    <div className="field">
                        <div className="title">
                            קוד דגם
                        </div>
                        <div className="value">
                            <Autocomplete Value={modelCode} Id="modelCode"
                                ClassName=''
                                OnChange={(s: string) => loadModelCode(s)}
                                OnSelect={selectModelCode}
                                OnFocus={onModelCodeFocus}
                                DataList={ModelcodeAutocomplete}

                                />
                            <img src={require("../assets/images/loading.gif")} className={modelCodeLoading ? "loadingGif" : "hide"} />
                        </div>
                    </div>
                </div>

                <div className="parameter-item">
                    <div className="field">
                        <div className="title">
                            שנה
                        </div>
                        <div className="value">
                            <DynamicSelect
                                OnChange={editCarYear}
                                // Disabled={true}
                                ClassName=""
                                Value={
                                    carYear
                                }
                                Options={
                                    CarYears.map((x: string) => ({ Text: x, Value: x }))
                                }
                                Id={"carYear"} />
                        </div>
                        <div className='error-message2'>{yearErrMsg}</div>
                    </div>
                </div>

                <div className="parameter-item">
                    <div className="field">
                        <div className="title">
                            בעלות
                        </div>
                        <div className="value">

                            <IDNameDescriptionItemSelect
                                OnChange={(e: any) => setVehicleOwnership(e.target.value)}
                                Id={"vehicleOwnership"}
                                Options={VehicleOwnerships}
                                Disabled={true}
                                Value={vehicleOwnership} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="parameter-row three-items">
                <div className="parameter-item">
                    <div className="field">
                        <div className="title">
                            חברה
                        </div>
                        <div className="value">
                            <input type="text" value={manufacturerText}
                                disabled
                            />
                        </div>
                    </div>
                </div>
                <div className="parameter-item">
                    <div className="field">
                        <div className="title">
                            דגם
                        </div>
                        <div className="value">
                            <input type="text" value={vehicleModelText}
                                disabled

                            />
                        </div>
                    </div>
                </div>
                <div className="parameter-item">
                    <div className="field">
                        <div className="title">
                            תת דגם
                        </div>
                        <div className="value">
                            <input type="text" value={vehicleSubModelText}
                                disabled

                            />
                        </div>
                    </div>
                </div>

            </div>
            <div className={"parameter-row"} >
                <div className='parameter-item'>
                    <div onClick={(e: any) => openVehiclePopup()} className={showVehicleDetails ? (missingVehicleDetails ? "editRed" : "edit") : "hide"}>
                        <FontAwesomeIcon icon={faPenToSquare} />
                        <div className={missingVehicleDetails ? "" : "hide"}>לא נמצאו פרטי רכב

                        </div>
                    </div>


                </div>
            </div>

            <div className={showVehiclePopup ? "" : "hide"}>
                <VehicleDetails manufacturerId={Vehicle && Vehicle.manufacturerId ? Vehicle.manufacturerId : ""} vehicleModelId={Vehicle && Vehicle.vehicleModelId ? Vehicle.vehicleModelId : ""}
                    vehicleSubModelId={Vehicle && Vehicle.vehicleSubModelId ? Vehicle.vehicleSubModelId : ""}
                    modelCode={Vehicle && Vehicle.modelCode ? Vehicle.modelCode : ""}
                    ClosePopup={() => closeVehiclePopup()}
                    tozeretCd={Vehicle ? Vehicle.tozeretCd : undefined}
                    degemCd={Vehicle ? Vehicle.degemCd : undefined}
                    GetVehicleSubmodelId={connectVehicle}
                    year={Vehicle && Vehicle.carYear?Vehicle.carYear:0}
                ></VehicleDetails>
            </div>
        </div>



    );
};

//export default forwardRef<ChildRef, Props>(VehicleData);
export default VehicleData;
